import BarcodesTable from './BarcodesTable'

export default BarcodesTable
